import { DateInput, Edit, FileInput, SimpleForm, TextInput } from "react-admin";

const ProductOfferedEdit = () => (
  <Edit>
    <SimpleForm>
      <FileInput source="file" label="Image du produit" />
      <TextInput source="item" label="Produit" />
      <TextInput source="voucher_type" label="Type" />
      <TextInput source="discount_value" label="Price" />
      <TextInput source="discount_type" label="Price Type" />
      <TextInput source="discount_type" label="Price Type" />
      <DateInput source="start_at" label="Start" />
      <DateInput source="end_at" label="End" />
    </SimpleForm>
  </Edit>
);

export default ProductOfferedEdit;
